import type { ILineItem, IOrderItem } from '~/modules/order-analytic';
import type { RendererProps } from './type';

import { CheckoutStartedDetail } from '~/presentation/journey/ui';
import { InlineStack, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useToggle } from '~/hooks/useToggle';

export const ItemsCell = ({ value }: Pick<RendererProps<IOrderItem[]>, 'value'>) => {
  const { t } = useTranslation();

  const { value: itemHovering, setTrue, setFalse } = useToggle(false);

  const lineItems: ILineItem[] = value.map((item) => ({
    imageURL: item.image_url,
    productTitle: item.product_title,
    quantity: Number(item.quantity),
    title: item.title,
  }));

  const getItemText = () => {
    const itemQuantity = value.reduce((acc, item) => acc + Number(item.quantity), 0);

    if (itemQuantity === 1) return t('{{itemQuantity}} item', { itemQuantity });

    return t('{{itemQuantity}} items', { itemQuantity });
  };

  return (
    <div onMouseEnter={setTrue} onMouseLeave={setFalse}>
      <InlineStack gap="200" blockAlign="center">
        <Text as="span" variant="bodyMd" tone="subdued">
          {getItemText()}
        </Text>

        <CheckoutStartedDetail
          lineItems={lineItems}
          activatorWrapperProps={{
            paddingBlockStart: '100',
            opacity: itemHovering ? '1' : '0',
          }}
        />
      </InlineStack>
    </div>
  );
};
